var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85902 2.87797L15.429 1.08197C15.5 1.07179 15.5723 1.07699 15.641 1.0972C15.7098 1.11741 15.7734 1.15216 15.8275 1.1991C15.8817 1.24605 15.9251 1.30408 15.9549 1.36928C15.9846 1.43447 16 1.5053 16 1.57697V22.424C16 22.4955 15.9846 22.5663 15.9549 22.6314C15.9252 22.6965 15.8819 22.7545 15.8279 22.8014C15.7738 22.8483 15.7103 22.8831 15.6417 22.9034C15.5731 22.9237 15.5009 22.929 15.43 22.919L2.85802 21.123C2.61964 21.089 2.40152 20.9702 2.24371 20.7883C2.08591 20.6065 1.99903 20.3738 1.99902 20.133V3.86797C1.99903 3.62718 2.08591 3.39448 2.24371 3.21261C2.40152 3.03075 2.62064 2.91192 2.85902 2.87797ZM17 2.99997H21C21.2652 2.99997 21.5196 3.10533 21.7071 3.29286C21.8947 3.4804 22 3.73475 22 3.99997V20C22 20.2652 21.8947 20.5195 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H17V2.99997ZM10.2 12L13 7.99997H10.6L9.00002 10.286L7.40002 7.99997H5.00002L7.80002 12L5.00002 16H7.40002L9.00002 13.714L10.6 16H13L10.2 12Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcel);
export default __webpack_public_path__ + "static/media/ic-excel.488947d524fee985ef1cc58f7470ae87.svg";
export { ForwardRef as ReactComponent };